import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

const getProcessingEntity = (tokens: any) => {
  const { REACT_APP_CHANNEL_ID = '' } = window?._env_
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.retrieveProcessingEntity),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      entity: {
        initiatingEntityId: REACT_APP_CHANNEL_ID,
      },
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getProcessingEntity }
